<template>
	<div>
		<div class="container hidden-xs">
			<b-breadcrumbs :items="breadcrumbs"/>
		</div>
		<delete-modal
			:show-modal="showDeleteModal"
			:details="currentPage"
			@closeDeleteModal="hideDeleteModal"
			@delete="deletePage"
		/>
		<section class="container">
			<div class="row">
				<div class="col-xs-12">
					<h1>Pages</h1>
					<div class="page-summary-container">
						<div class="page-summary-text">
							Add, edit &amp; delete pages
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-7 col-sm-9">
					<div class="input-group">
						<input
							v-model="searchTerm"
							type="text"
							class="form-control"
							style="height:40.25px;"
							placeholder="Search pages"
							@keyup.enter="search"
						>
						<span class="input-group-btn">
							<b-btn class="btn-primary" @click="search">
								<i class="material-icons">search</i>
							</b-btn>
						</span>
					</div>
				</div>
				<div class="col-xs-5 col-sm-3">
					<router-link
						to="/admin/pages/new"
						class="btn btn-info btn-md btn-block btn-filter-admin"
						data-toggle="collapse"
						aria-expanded="false"
						role="button"
					>
					Add new
					</router-link>
				</div>
			</div>
			<template v-if="loading">
				<div class="row">
					<div class="col-xs-12">
						<div class="container loading-container">
							<img class="section-loader" src="@/assets/images/iadsa-section-loader-admin.gif"/>
						</div>
					</div>
				</div>
			</template>
			<template v-else-if="pages && pages.length > 0">
				<div
					v-for="page in pages"
					:key="page.id"
					class="list-container list-container-notifications"
				>
					<div class="row">
						<div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
							<div class="sm-padding-bottom-10">
								<div class="notification-list-heading">
									{{ page.title }}
								</div>
							</div>
						</div>
						<div class="col-xs-5 col-sm-6 col-md-6 col-lg-6">
							<div class="sm-padding-bottom-10">
								{{ page.meta_description }}
							</div>
						</div>
						<div class="col-xs-3 col-sm-2 col-md-2 col-lg-1 pull-right">
							<b-dropdown class="btn-group" :menu-right="true">
								<b-btn class="btn btn-primary btn-sm dropdown-toggle">
									Actions
									<span class="form-label sr-only">Toggle Dropdown</span>
								</b-btn>
								<template slot="dropdown">
									<li>
										<router-link :to="`/admin/pages/${page.id}`" role="button">
											Edit
										</router-link>
									</li>
									<li>
										<a
											@click="showDeleteModal=true; openDeleteModal(page)"
											role="button"
										>Delete</a>
									</li>
								</template>
							</b-dropdown>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="row">
					<div class="col-xs-12">
						<div class="container center">
							<h2>No results found</h2>
						</div>
					</div>
				</div>
			</template>
			<div class="row">
				<div class="col-xs-12">
					<div class="pagination-container">
						<b-pagination
							v-if="pagination && pagination.totalPages > 1"
							v-model="pagination.page"
							:total-page="pagination.totalPages"
						/>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<style lang="less" scoped>
	.input-group {
		margin-bottom: 30px;
	}
	.btn-primary {
		height: 40.25px;
	}
	.loading-container {
		text-align: center;
	}
	.section-loader {
		max-width: 200px;
		height: auto;
		margin: 30px auto;
	}
</style>

<script>
import deleteModal from '@/components/delete-modal';
import { Notification } from 'uiv';
import { mapGetters } from 'vuex';
import { determineNextPageOnDelete } from '@/modules/utils';

export default {
	components: { deleteModal },
	created() {
		this.getPages();
	},
	data() {
		return {
			searchTerm: null,
			pages: null,
			pagination: {
				page: 1
			},
			showDeleteModal: false,
			currentPage: {
				id: null,
				name: null
			},
			loading: false
		};
	},
	methods: {
		openDeleteModal(page) {
			this.currentPage.name = page.title;
			this.currentPage.id = page.id;
		},
		hideDeleteModal() {
			this.showDeleteModal = false;
		},
		async getPages(params) {
			this.loading = true;
			const { searchTerm } = this;

			const { data: { data: pages, pagination } } = await this.$axios.get('/page', {
				params: {
					searchTerm,
					page: this.pagination.page,
					...params
				}
			});
			this.$set(this, 'pages', pages);
			this.$set(this, 'pagination', pagination);
			this.loading = false;
		},
		async deletePage(id) {
			await this.$axios.delete(`/page/${id}`);
			// if this is the last item in a page, render the previous page; current page limit is 20
			const page = determineNextPageOnDelete(this.pagination, 20);
			this.getPages({ page });

			this.hideDeleteModal();
			Notification.notify({
				type: 'danger',
				title: 'Page deleted',
				content: `Successfully deleted ${this.currentPage.name}.`,
				duration: 10000
			});
		},
		async search() {
			await this.getPages({ page: 1 });
		},
	},
	computed: {
		...mapGetters({ getBreadcrumbs: 'breadcrumbs' }),
		breadcrumbs() {
			return this.getBreadcrumbs;
		}
	},
	watch: {
		'pagination.page': async function pageWatcher() {
			await this.getPages();
		}
	},
};
</script>
